<mat-toolbar class="menu">
  <img src="assets/img/logo_vallourec_upload.svg" alt="Logo Vallourec Upload">
  <span class="menu-spacer"></span>
  <a href="assets/pdf/vallourec_upload_procedure.pdf" target="_blank">
    <button class="vlr-text-link-btn vlr-icon-btn">
      <mat-icon>picture_as_pdf</mat-icon>
      <span>User Guide</span>
    </button>
  </a>
  <a href="https://confluence.vallourec.net/display/cloud/Vallourec+Upload+Translation+feature" target="_blank" *ngIf="(auth.internal | async)">
    <button class="vlr-text-link-btn vlr-icon-btn">
      <mat-icon>translate</mat-icon>
      <span>Translation Guide</span>
    </button>
  </a>
  <button class="vlr-secondary-btn vlr-icon-btn" *ngIf="(auth.loggedIn | async)" (click)="signOut()">
    <mat-icon>power_settings_new</mat-icon>
    <span>Sign Out</span>
  </button>
</mat-toolbar>

